export default "__VITE_ASSET__6f0da6d9__"